import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const HashIcon = (p: IconProps) => <Icon {...p}><path d="M4 9h16M4 15h16M10 3v18M14 3v18" /></Icon>
